import { DefaultState, DropdownItem } from 'store/types';

export const READ_LODGING_FORM_DATA_REQUEST = 'READ_LODGING_FORM_DATA_REQUEST';
export const READ_LODGING_FORM_DATA_SUCCESS = 'READ_LODGING_FORM_DATA_SUCCESS';
export const READ_LODGING_FORM_DATA_FAILURE = 'READ_LODGING_FORM_DATA_FAILURE';

export interface LodgingFormData {
  lodgingTypes: Array<DropdownItem>;
  name: string;
  lodgingType: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  location: {
    longitude: number;
    latitude: number;
  };
  checkInDetails?: string;
  checkOutDetails?: string;
  notes?: string;
  website?: string;
  lodgingManager: {
    name: string;
    phoneNumber: string;
    email?: string;
  };
}

export type LodgingFormDataState = DefaultState & {
  contents?: LodgingFormData;
};

interface ReadLodgingFormDataRequest {
  type: typeof READ_LODGING_FORM_DATA_REQUEST;
};

interface ReadLodgingFormDataSuccess {
  type: typeof READ_LODGING_FORM_DATA_SUCCESS,
  contents: LodgingFormData;
}

interface ReadLodgingFormDataFailure {
  type: typeof READ_LODGING_FORM_DATA_FAILURE;
}

export type LodgingFormDataActionTypes = ReadLodgingFormDataRequest | ReadLodgingFormDataSuccess | ReadLodgingFormDataFailure;